import { Col, Row, Switch } from "antd";
import { get } from "lodash";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { DELTA_END_TYPES, PERIOD_UNITS } from "utils/constants";
import { bindInputProps } from "utils/helpers/input";

const QuoteValidityRow = ({
  FORM,
  basePath,
  values,
  setFieldValue,
  ...formProps
}) => {
  const type = get(values, `${basePath}.type`);
  const isPeriod = type === DELTA_END_TYPES.ADD_PERIOD;

  return (
    <Row gutter={[16, 16]} align={"middle"}>
      <Col span={4}>{FORM.CONDITIONS.QUOTE_VALIDITY}</Col>
      <Col span={20}>
        <Row align={"middle"} gutter={8}>
          <Col flex={1}>
            <Select
              options={Object.entries(DELTA_END_TYPES).map(([key, value]) => ({
                label: FORM.CONDITIONS.QUOTE_VALIDITY_OPTIONS[key],
                value,
              }))}
              allowClear
              placeholder={FORM.CONDITIONS.QUOTE_VALIDITY}
              {...bindInputProps({
                name: `${basePath}.type`,
                values,
                ...formProps,
              })}
              onChange={(value) => {
                if (!value) return setFieldValue(basePath, null);
                setFieldValue(`${basePath}.type`, value);
                if (value === DELTA_END_TYPES.END_OF_YEAR) {
                  setFieldValue(`${basePath}.value`, null);
                  setFieldValue(`${basePath}.unit`, null);
                  setFieldValue(`${basePath}.limitEndOfYear`, false);
                }
              }}
            />
          </Col>
          {isPeriod && (
            <>
              <Col span={9}>
                <Input
                  type="number"
                  placeholder={FORM.CONDITIONS.NUMBER_OF}
                  {...bindInputProps({
                    name: `${basePath}.value`,
                    values,
                    ...formProps,
                  })}
                />
              </Col>
              <Col span={5}>
                <Select
                  options={Object.entries(PERIOD_UNITS).map(([key, value]) => ({
                    label: FORM.CONDITIONS[key],
                    value,
                  }))}
                  placeholder={FORM.CONDITIONS.UNIT}
                  {...bindInputProps({
                    name: `${basePath}.unit`,
                    values,
                    ...formProps,
                  })}
                />
              </Col>
            </>
          )}
        </Row>
        {isPeriod && (
          <Row align={"middle"} gutter={8} className="m-top-8">
            <Col>{FORM.CONDITIONS.QUOTE_VALIDITY_LIMIT_END_OF_YEAR}</Col>
            <Col>
              <Switch
                checked={get(values, `${basePath}.limitEndOfYear`) === true}
                onChange={(checked) =>
                  setFieldValue(`${basePath}.limitEndOfYear`, checked)
                }
              />
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default QuoteValidityRow;
